export default "__VITE_ASSET__YZM81tEe__"